const getters = {
  roles: state => state.roles,
  permissions: state => state.permissions,
}

export default getters;
